<script setup lang="ts">
import { computed } from 'vue';

// Surfaced by the API's callback redirect. Each message says what to do next
// rather than restating that something failed.
const MESSAGES: Record<string, string> = {
  wrong_domain: 'That is not a company account. Sign in with your @lionsbot.com address.',
  disabled: 'This account has been deactivated. Contact finance if that looks wrong.',
  unverified: 'That Google account has an unverified email address.',
  bad_state: 'The sign-in link expired. Please try again.',
  auth_failed: 'Google could not verify that sign-in. Please try again.',
  cancelled: 'Sign-in was cancelled.',
};

const error = computed(() => {
  const code = new URLSearchParams(window.location.search).get('error');
  if (!code) return null;
  return MESSAGES[code] ?? 'Sign-in did not complete. Please try again.';
});
</script>

<template>
  <main class="centered-page">
    <div class="form-section signin-card">
      <div>
        <h1>Griffin Finance</h1>
        <p class="signin-sub">Purchase requests and supplier invoices.</p>
      </div>

      <div
        v-if="error"
        role="alert"
        class="signin-error"
      >{{ error }}</div>

      <a class="btn primary" href="/auth/login">Sign in with Google</a>

      <p class="hint signin-foot">Use your company Google account.</p>
    </div>
  </main>
</template>

<style scoped>
.signin-card {
  margin-top: 0;
  width: 100%;
  max-width: 380px;
  padding: 2.25rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
}
h1 { font-size: 19px; font-weight: 600; letter-spacing: -0.02em; }
.signin-sub { color: var(--text-muted); font-size: 13px; margin-top: 3px; }
.signin-error {
  background: var(--danger-bg);
  color: var(--danger-text);
  border: 0.5px solid var(--danger-text);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  font-size: 13px;
  text-align: left;
}
.signin-foot { text-align: center; }
</style>
